import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box } from '@material-ui/core';
import AWS from 'aws-sdk';

import { GetCourseByUser, GetTopicById, UpdateFilePracticalCaseByUser } from '../../../services/courses';
import { setAnalytics } from '../../../utils';
import Headers from '../Headers';

import PracticalCase from './PracticalCase';

function ContainerPracticalCaseSection() {
  const location = useLocation();
  const navigate = useNavigate();
  const [file, setFile] = useState('');
  const [sizeFile, setSizeFile] = useState(0);
  const [nameFile, setNameFile] = useState('');
  const [dataContent, setDataContent] = useState('');
  const [sendFile, setSendFile] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);

  const S3_BUCKET = process.env.REACT_APP_AWS_BUCKET_KEY;
  const REGION = process.env.REACT_APP_AWS_REGION;

  AWS.config.update({
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
  });

  const myBucket = new AWS.S3({
    params: { Bucket: S3_BUCKET },
    region: REGION,
  });

  const clearFile = () => {
    setFile('');
    setSizeFile(0);
    setNameFile('');
  };

  const changeInputValue = (e) => {
    setFile(e.target.files[0]);
    setNameFile(e.target.files[0].name);
    const sizeInMB = (e.target.files[0].size / (1024 * 1024));
    setSizeFile(sizeInMB);
  };
  const getContentToPracticalCase = async () => {
    const topicById = await GetTopicById(location.state.topic);
    setDataContent(topicById.data.practicalCase[0]);
    const courseByUser = await GetCourseByUser(location.state.idUser, location.state.course);
    const topicByUser = courseByUser.data[0].topicsByUser.find(
      (e) => e.idTopic === location.state.topic,
    );
    const practicalCase = topicByUser.practicalCaseByUser[0].file;
    setSendFile(practicalCase !== undefined);
  };

  const uploadFileToS3 = async () => {
    setUpdateLoading(true);
    const params = {
      ACL: 'public-read',
      Body: file,
      Bucket: S3_BUCKET,
      Key: `practical-cases-users/${location.state.topic}-${
        location.state.idUser
      }.${nameFile.split('.').pop()}`,
    };
    try {
      setAnalytics('Lesson', 'Btn_FinalizarCurso');
      const { Location } = await myBucket.upload(params).promise();
      const dataUpdateFile = {
        idPracticalCaseUser: location.state.practicalId,
        file: Location,
        idUser: location.state.idUser,
        idCourse: location.state.course,
        idTopic: location.state.topic,
        idTopicUser: location.state.idTopicUser,
        idFinalProjectUser: location.state.finalProjectUserId,
      };
      const responseUpdateFile = await UpdateFilePracticalCaseByUser(dataUpdateFile);
      if (responseUpdateFile.data.completedTopic) {
        setUpdateLoading(false);
        setFile('');
        setSendFile(true);
        navigate('/finished', {
          state: {
            name: location.state.nameCourse,
            theme: true,
            finalCourse: false,
            course: location.state.course,
          },
        });
      } else {
        setUpdateLoading(false);
        navigate('/lesson', {
          state: {
            ...location.state,
          },
        });
        setFile('');
        setSendFile(true);
      }
      return Location;
    } catch (error) {
      console.log(error.message);
    }
    return Location;
  };

  useEffect(() => {
    getContentToPracticalCase();
  }, []);
  return (
    <Box>
      <Headers />
      <PracticalCase
        file={file}
        changeInputValue={changeInputValue}
        nameFile={nameFile}
        uploadFileToS3={uploadFileToS3}
        isFinalProject={false}
        content={dataContent.description}
        fileSend={sendFile}
        isLoading={updateLoading}
        sizeFile={sizeFile}
        clearFile={clearFile}
      />
    </Box>
  );
}

export default ContainerPracticalCaseSection;
